import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

import Button from '@components/Button'

class EPLQuickSearch extends Component {
  static propTypes = {
    eplStore: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object
  }

  componentDidMount () {
    document.getElementById('expert-quick-search-input').focus()
    window.addEventListener('keydown', this.onKeyDown)
  }

  componentWillUnmount () {
    window.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown = e => {
    if (e.altKey && e.code === 'KeyS') {
      e.preventDefault()
      document.getElementById('expert-quick-search-input').focus()
    }
  }

  resetSearch = () => {
    const { eplStore, history } = this.props

    eplStore.isExpertQuickSearchActive = false
    eplStore.expertQuickSearchValue = ''
    if (eplStore.expertQuickSearchPreviousUrl) {
      history.replace(eplStore.expertQuickSearchPreviousUrl)
      eplStore.expertQuickSearchPreviousUrl = null
    } else {
      // meaning the previous URL was experts-pipeline so we need to refresh EPLs
      eplStore.getList(eplStore.projectId)
    }
  }

  onInputChange = value => {
    const { eplStore, history, match } = this.props

    eplStore.isExpertQuickSearchActive = true
    eplStore.expertQuickSearchValue = value

    const newUrl = match.url + '/experts-pipeline'
    if (newUrl !== history.location.pathname) {
      eplStore.expertQuickSearchPreviousUrl = history.location.pathname
      history.replace(newUrl)
    }

    if (value.length > 2) {
      eplStore.quickSearch()
    }
  }

  render () {
    const { eplStore } = this.props

    return (
      <span className='expert-quick-search'>
        <div>Expert search: </div>
        <div className='expert-form__input-wrapper'>
          <input
            id='expert-quick-search-input'
            className='expert-form__input'
            type='text'
            value={eplStore.expertQuickSearchValue}
            onChange={e => this.onInputChange(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Escape') {
                this.resetSearch()
              }
            }}
          />
        </div>
        <div>
          <div
            style={
              !eplStore.isExpertQuickSearchActive ? { display: 'none' } : null
            }
          >
            <Button onClick={this.resetSearch}>Reset</Button>
          </div>
        </div>
      </span>
    )
  }
}

export default withRouter(inject('eplStore')(observer(EPLQuickSearch)))
